import { createSelector } from 'reselect'
import has from 'lodash/has'
import mapValues from 'lodash/mapValues'
import { selectHighestRateLoanDictionary } from './home/dictionary'

const getHasHomeData = state => Boolean(state.home.data)

export const selectSettingsMap = state => mapValues(state.airDna, 'settings')

export const selectParamsMap = state => mapValues(state.airDna, 'params')

/*
 * Represents a given set of airdna data for a component's stateKey
 */
const getPropertyDetails = ({ data = {}, settings }) => {
  if (!data.propertyStats) {
    return {}
  }

  const { adr, revenue, occupancy } = data.propertyStats
  const { nightsPerMonth, pricePerNight } = settings
  const paymentMax = adr.ltm
  const rentalNightMax = occupancy.ltm * 30

  const monthlyOccupancy = nightsPerMonth
    ? parseFloat(parseInt(nightsPerMonth, 10) / rentalNightMax)
    : 1
  const nightlyRate = pricePerNight
    ? parseFloat(parseInt(pricePerNight, 10) / paymentMax)
    : 1
  const monthlyRevenue = 1 * monthlyOccupancy * nightlyRate
  const annualEarnings = revenue.ltm * monthlyRevenue
  const monthlyEarnings = annualEarnings / 12

  return {
    rentalNightMax,
    monthlyRevenue,
    monthlyEarnings,
    annualEarnings,
    paymentMax,
  }
}

const getPropertyDetailsMap = airDnaState =>
  mapValues(airDnaState, getPropertyDetails)

export const selectPropertyDetailsMap = createSelector(
  state => state.airDna,
  getPropertyDetailsMap
)

const getPropertyDetailsPerHome = (detailsMap, hasHomeData, dictionary) => {
  if (!hasHomeData) {
    return detailsMap
  }

  return mapValues(detailsMap, branch => {
    const amt = branch.monthlyEarnings

    if (!amt) {
      return branch
    }

    return Object.assign({}, branch, {
      extraPaymentSavings: dictionary.extraPaymentSavingsTotal({ amt }),
      extraPaymentYears: dictionary.extraPaymentYears({ amt }),
    })
  })
}

export const selectPropertyDetailsMapWithHome = createSelector(
  selectPropertyDetailsMap,
  getHasHomeData,
  selectHighestRateLoanDictionary,
  getPropertyDetailsPerHome
)

export const selectHasRequestDataMap = createSelector(
  state => state.airDna,
  airDna => mapValues(airDna, branch => has(branch, 'data.propertyStats'))
)
